{
  "pending": "beklemede"
}
